
export default function AboutTeam() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Notre <span className="text-red-600">Équipe</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des professionnels passionnés et expérimentés à votre service
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-8 md:p-12">
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                Notre équipe est composée de professionnels hautement qualifiés et expérimentés dans le domaine de la sécurité électronique. Dirigée par des experts ayant plus de 20 ans d'expérience dans l'industrie, COBRA SECURITE rassemble des techniciens certifiés, des ingénieurs spécialisés et des conseillers commerciaux dédiés à la satisfaction de nos clients.
              </p>
              <p>
                Chaque membre de notre équipe suit régulièrement des formations techniques pour rester à la pointe des dernières innovations en matière de sécurité. Nos techniciens sont certifiés par les plus grands fabricants d'équipements de sécurité et maîtrisent parfaitement l'installation, la configuration et la maintenance de tous types de systèmes de protection.
              </p>
              <p>
                Notre force réside dans la complémentarité de nos compétences : de la conception technique à l'installation sur site, en passant par le conseil personnalisé et le service après-vente, nous vous accompagnons à chaque étape de votre projet de sécurisation. Cette approche collaborative nous permet de garantir des solutions parfaitement adaptées à vos besoins spécifiques.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
